import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=015e2f54&scoped=true&"
import script from "./answerDetail.vue?vue&type=script&lang=js&"
export * from "./answerDetail.vue?vue&type=script&lang=js&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=015e2f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e2f54",
  null
  
)

export default component.exports